import Header from "@/components/hotel/Header";
import SubpageHero from "@/components/hotel/SubpageHero";
import About from "@/components/hotel/About";
import HotelInfo from "@/components/hotel/HotelInfo";
import Footer from "@/components/hotel/Footer";
import SEO from "@/components/SEO";
import { useLanguage } from "@/i18n/LanguageContext";

const AboutPage = () => {
  const { t } = useLanguage();
  return (
    <main id="main-content" className="min-h-screen bg-background">
      <SEO
        title="Über uns"
        description="Erfahren Sie mehr über das ESOS Hotel Quelle in Bad Ragaz – Geschichte, Tradition und Schweizer Gastfreundschaft seit Jahren."
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Über uns", path: "/about" },
        ]}
      />
      <Header />
      <SubpageHero title={t.subpageHeroes.about.title} subtitle={t.subpageHeroes.about.subtitle} />
      <About />
      <HotelInfo />
      <Footer />
    </main>
  );
};

export default AboutPage;
